import React from 'react';
import { FoundersAnatomyOfEndurance } from './FoundersAnatomyOfEndurance';
export function Founders() {
  return <FoundersAnatomyOfEndurance data-id="element-523" />;
}